export const TRIAL_TYPES = {
  TRIAL: 'trial',
  TREATMENT: 'drug',
};

export const TREATMENT_GROUPS = [
  'Radiation',
  'Imaging',
  'Medical Device',
  'Targeted therapy',
  'Diagnostics',
  'Cell Therapy',
  'Immunotherapy',
  'Gene Therapy',
  'Chemotherapy',
  'Vaccine',
  'Hormonal Therapy',
  'Oncolytic Virus Therapy',
];
